<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18.4265 4.1808L8.42654 11.1808C7.85782 11.5789 7.85782 12.4212 8.42654 12.8193L18.4265 19.8193C19.0893 20.2832 20 19.8091 20 19V5.00003C20 4.19101 19.0893 3.71685 18.4265 4.1808ZM5 4.00003C4.44772 4.00003 4 4.44775 4 5.00003V19C4 19.5523 4.44772 20 5 20C5.55228 20 6 19.5523 6 19V5.00003C6 4.44775 5.55228 4.00003 5 4.00003ZM18 6.92069V17.0794L10.7438 12L18 6.92069Z"
    fill="currentColor"
  />
</svg>
